import(/* webpackMode: "eager" */ "/my-ai-project/app/globals.css");
import(/* webpackMode: "eager" */ "/my-ai-project/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/my-ai-project/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/my-ai-project/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/my-ai-project/components/ui/tooltip.tsx")